import { blogActions } from '@/actions';
import { Fab } from '@/components/elements/forms/buttons';
import { ArrowIcon } from '@/components/icons';
import { ArchiveLayout } from '@/components/layouts/blog';
import { isServer } from '@/helpers';
import { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import ArchivePost from './ArchivePost';
import LoadingPosts from './LoadingPosts';

const DCCategoryArchive = ({ page: ssrPage, posts: ssrPosts, category: ssrCategory }) => {
  const [page, setPage] = useState(ssrPage || { current: 1, total: 0 });
  const [posts, setPosts] = useState(ssrPosts || []);
  const [loading, setLoading] = useState(false);
  const mounted = useRef(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const [currentSlug, setCurrentSlug] = useState(null);

  const { pathname } = useLocation();
  const parts = isServer ? '' : pathname.split('/').filter((p) => p);
  const hasPage = !isNaN(parseInt(parts[parts.length - 1]));
  const slug = hasPage ? parts[parts.length - 2] : parts[parts.length - 1];
  const urlPage = hasPage ? parts[parts.length - 1] : 1;

  const fetchPosts = (slug, page) => {
    const numPage = page && page > 1 ? parseInt(page) : 1;
    history.push(`/blogg/c/${slug}/${numPage > 1 ? numPage : ''}`);
    setLoading(true);
    setCurrentSlug(slug);
    // @ts-ignore
    dispatch(blogActions.category(slug, numPage));
  };

  useEffect(() => {
    if (!mounted.current) {
      if (!ssrPosts) {
        fetchPosts(slug, urlPage);
      }
      mounted.current = true;
    } else {
      if (posts !== ssrPosts) {
        setPosts(ssrPosts);
        setPage(ssrPage || { current: 1, total: 0 });
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    if (isServer) return;
    window.scrollTo(0, 0);
  }, [page]);

  useEffect(() => {
    if (slug === currentSlug) return;
    fetchPosts(slug, 1);
  }, [pathname]);

  const nextPage = () => parseInt(page.total) >= page.current + 1 && fetchPosts(slug, page.current + 1);
  const prevPage = () => parseInt(page.current) > 1 && fetchPosts(slug, page.current - 1);

  return (
    <div className="mb-32">
      <ArchiveLayout>
        {loading ? (
          <LoadingPosts />
        ) : (
          posts && posts.length && posts.map((post, i) => <ArchivePost post={post} key={i} />)
        )}
      </ArchiveLayout>
      {!loading && posts && posts.length && (
        <div className="flex justify-center">
          <Fab
            icon={<ArrowIcon className="h-5 w-5 rotate-180" />}
            onClick={prevPage}
            size="md"
            variant="secondary"
            disabled={page.current <= 1}
            className="hover:bg-primary !mr-10 border bg-transparent hover:text-white"
          />
          <Fab
            icon={<ArrowIcon className="h-5 w-5" />}
            onClick={nextPage}
            size="md"
            variant="secondary"
            disabled={page.current + 1 > page.total}
            className="hover:bg-primary border bg-transparent hover:text-white"
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { page, posts, category } = state.blog;

  return {
    page,
    posts,
    category,
  };
};

const CategoryArchive = connect(mapStateToProps)(DCCategoryArchive);

export default CategoryArchive;
